/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
//import '@angular/localize/init';

// tslint:disable no-import-side-effect
import 'intl';
import 'intl/locale-data/jsonp/en-US.js';
import 'intl/locale-data/jsonp/en-GB.js';
import 'intl/locale-data/jsonp/es-ES.js';
import 'intl/locale-data/jsonp/fr-FR.js';
import 'intl/locale-data/jsonp/fr-CH.js';
import 'intl/locale-data/jsonp/fr-BE.js';
import 'intl/locale-data/jsonp/it.js';
import 'intl/locale-data/jsonp/pt-PT.js';
import 'intl/locale-data/jsonp/pt-BR.js';

import 'zone.js';
import 'reflect-metadata';
import 'datejs';
